import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../../assets/images/logonew.png';
import '../Footer/footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer__inner">
        <div className="footer__grid">
          <div className="footer__brand">
            <Link to="/" className="footer__logo-link">
              <img src={logo} alt="NeoApps" className="footer__logo" />
            </Link>
            <p className="footer__tagline">
              We design and build modern websites and mobile apps for businesses that want to grow
              with technology.
            </p>
            <a href="mailto:info@neoappslab.com" className="footer__email">
              info@neoappslab.com
            </a>
          </div>

          <div className="footer__col">
            <h4 className="footer__heading">Company</h4>
            <nav className="footer__links">
              <Link to="/about">About</Link>
              <Link to="/team">Team</Link>
              <Link to="/portfolio">Portfolio</Link>
            </nav>
          </div>

          <div className="footer__col">
            <h4 className="footer__heading">Services</h4>
            <nav className="footer__links">
              <Link to="/services">All services</Link>
              <Link to="/contact">Get a quote</Link>
              <Link to="/contact">Contact us</Link>
            </nav>
          </div>

          <div className="footer__col">
            <h4 className="footer__heading">Follow us</h4>
            <div className="footer__social">
              <a
                href="https://www.facebook.com/p/Neoapps-61555786269652/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="NeoApps on Facebook"
              >
                <i className="ri-facebook-circle-fill" />
              </a>
              <a
                href="https://www.instagram.com/neoapps_services/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="NeoApps on Instagram"
              >
                <i className="uil uil-instagram-alt" />
              </a>
              <a
                href="https://x.com/NeoappsServices"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="NeoApps on X"
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="1.1em" height="1.1em" viewBox="0 0 16 16" aria-hidden="true">
                  <path
                    fill="currentColor"
                    d="M12.6.75h2.454l-5.36 6.142L16 15.25h-4.937l-3.867-5.07l-4.425 5.07H.316l5.733-6.57L0 .75h5.063l3.495 4.633L12.601.75Zm-.86 13.028h1.36L4.323 2.145H2.865z"
                  />
                </svg>
              </a>
            </div>
            <Link to="/contact" className="footer__cta">
              Start a project
            </Link>
          </div>
        </div>

        <div className="footer__bottom">
          <p>© {new Date().getFullYear()} NeoApps. All rights reserved.</p>
          <p className="footer__domain">neoappslab.com</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
